import React from 'react';
import QueueAnim from 'rc-queue-anim';
import ResetPassword1 from 'routes/form/routes/forms/components/ResetPassword1';

const FormCard = () => (
  <section className="form-card-page  row no-gutters">

    <div className="card  border-0 form-card__body offset-lg-3 p-5 px-lg-4 d-flex align-items-center justify-content-center mt-5">
      <ResetPassword1 />
    </div>
  </section>
)

const Page = () => (
  <QueueAnim type="bottom" className="ui-animate">
    <div key="1">
      <FormCard />
    </div>
  </QueueAnim>
)

export default Page;
